import React from 'react';
import * as analytics from '../lib/analytics';

import content from '../lib/i18n';
const i18n = content('hub/components/socialShare');

export default class extends React.Component {
  handleClick = event => {
    event.preventDefault();
  };

  handleFBClick = (socialShareType, url) => {
    let fbShareMsg = i18n('label.fbShareMsg');
    let name = i18n('label.fbShareName');
    let link = url;
    let caption = i18n('label.fbCaption');
    let picture = 'https://www.paypalobjects.com/webstatic/icon/pp258.png';
    let constructUrl = `https://www.facebook.com/dialog/feed?app_id=321983581337375&name=${name}&display=popup&caption=${caption}&description=${fbShareMsg}&picture=${picture}&link=${link}`;
    window.open(
      constructUrl,
      'facebook',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );

    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleAnalytics = socialShareType => {
    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  render() {
    let twitterShareMsg = i18n('label.twitterShareMsg');
    let mailShareMsg = i18n('label.mailShareMsg');
    let twitterUrl = encodeURI(
      'https://twitter.com/intent/tweet?url=www.paypal.com&text=' +
        twitterShareMsg
    );
    let mailSubject = i18n('label.mailSubject');
    let mailUrl = `mailto:?subject=${mailSubject}&body=${mailShareMsg}`;

    return (
      <div className='share'>
        <ul>
          <li className='facebook'>
            <a
              onClick={this.handleFBClick.bind(
                this,
                'facebookshare',
                this.props.url
              )}
            >
              {i18n('label.fbLink')}
            </a>
          </li>
          <li className='twitter'>
            <a
              onClick={this.handleAnalytics.bind(this, 'twittershare')}
              href={twitterUrl}
              target='_blank'
            >
              {i18n('label.twitterLink')}
            </a>
          </li>
          <li className='email'>
            <a
              onClick={this.handleAnalytics.bind(this, 'mailshare')}
              href={mailUrl}
            >
              {i18n('label.mailLink')}
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
